<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre11" id="pgepubid00006">ILLUSTRATIONS</h2>
<table border="0" cellpadding="5" cellspacing="0" class="calibre12" summary="Illustrations">
<colgroup class="calibre13"><col class="calibre18"/>
<col class="calibre14"/>
</colgroup>
<tbody class="calibre16"><tr class="calibre17">
<th class="calibre19"> </th>
<th class="smfontr">PAGE</th>
</tr>
<tr class="calibre17">
<td class="tdl2"><div class="noi2"><a href="#/Text/Section0002#i_frontis"><span class="smcap1">“We Taught Those Thar
Red Demons a Lesson They’ll Not Forget.” </span></a><span class="flright1"> <i class="calibre9">Frontispiece</i></span></div>
</td>
<td class="tdrb"> </td>
</tr>
<tr class="calibre17">
<td class="tdl3"><a href="#/Text/Section0007#i_fp022"><span class="smcap1">Christopher Carson</span></a></td>
<td class="tdrb">22</td>
</tr>
<tr class="calibre17">
<td class="tdl3"><span href="#/Text/Section0011#i_fp071" title="Link target outside of Sample"><span class="smcap1">John Charles Frémont</span></span></td>
<td class="tdrb">71</td>
</tr>
<tr class="calibre17">
<td class="tdl3"><span href="#/Text/Section0013#i_fp104" title="Link target outside of Sample"><span class="smcap1">The First Buffalo Had Fallen to the
Crack of Kit Carson’s Rifle</span></span></td>
<td class="tdrb">104</td>
</tr>
<tr class="calibre17">
<td class="tdl3"><span href="#/Text/Section0015#i_fp130" title="Link target outside of Sample"><span class="smcap1">As the Boat Came Whirling Down,
Helpless and Inert, Heads Broke Up Around It</span></span></td>
<td class="tdrb">130</td>
</tr>
<tr class="calibre17">
<td class="tdl3"><span href="#/Text/Section0024#i_fp232" title="Link target outside of Sample"><span class="smcap1">Kit and the Lieutenant Showed the
Three, by Signs, How from the Rifles and Carbines Could Speed a Bullet and Bore Them Through
and Through</span></span></td>
<td class="tdrb">232</td>
</tr>
</tbody>
</table>
<p class="calibre8"><span id="pgepubid00007" title="[13]"><a id="Page_13" title="[13]"></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?4ce0d708